import './offer.component.scss';

export class DoubleAdditionalOfferController {
}

export const doubleAdditionalOfferComponent = {
    template: require('./doubleAdditionalOffer.component.html'),
    controller: DoubleAdditionalOfferController
};